import { createGlobalStyle } from "styled-components"

export const PageWithoutScroll = createGlobalStyle`
  html {
    overflow: hidden;
  }
`
